import { AppConfig,AppSlugs } from '@hcs/types';

import { useBundleAppConfigs } from './useBundleAppConfigs';

export const useAppConfig = (appSlug: AppSlugs): AppConfig | undefined => {
  const bundleAppConfigs = useBundleAppConfigs();
  return bundleAppConfigs?.find((c) => c.appSlug === appSlug);
};
